/**
 * Helper component for rendering textarea inputs
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import components
import Base from "../BaseComponent.js.jsx";

class TextAreaInput extends Base {
  constructor(props) {
    super(props);
    this._bind('_handleInputChange');
  }

  _handleInputChange(e) {
    this.props.change(e);
  }

  render() {
    const {
      cols
      , disabled
      , helpText
      , label
      , maxLength
      , name
      , placeholder
      , required
      , rows
      , value
    } = this.props;
    return (
      <div className="input-group">
        <label htmlFor={name}> {label} {required ? <sup className="-required">*</sup> : null}</label>
        <textarea
          cols={cols}
          maxLength={maxLength}
          name={name}
          onChange={this._handleInputChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          type="text"
          value={value}
          wrap="hard"
          disabled={disabled}
        >
        </textarea>
        <small className="help-text"><em>{helpText}</em></small>
      </div>
    )
  }
}

TextAreaInput.propTypes = {
  change: PropTypes.func.isRequired
  , cols: PropTypes.number
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string
  , maxLength: PropTypes.string
  , name: PropTypes.string.isRequired
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , rows: PropTypes.string
  , value: PropTypes.string.isRequired
}

TextAreaInput.defaultProps = {
  disabled: false
  , helpText: null
  , label: ''
  , maxLength: null
  , placeholder: ''
  , required: false
  , rows: '4'
}

export default TextAreaInput;



// WEBPACK FOOTER //
// global/components/forms/TextAreaInput.js.jsx